import {message} from '@sail/intl';

// Section titles
export const productsSectionTitle = message({
  id: 'mkt-ssr.footer.products_section_title',
  defaultMessage: 'Products & pricing',
  description: 'The title for the products section of the footer',
});

export const solutionsSectionTitle = message({
  id: 'mkt-ssr.footer.solutions_section_title',
  defaultMessage: 'Solutions',
  description: 'The title for the solutions section of the footer',
});

export const integrationsSectionTitle = message({
  id: 'mkt-ssr.footer.integrations_section_title',
  defaultMessage: 'Integrations & custom solutions',
  description: 'The title for the integrations section of the footer',
});

export const developersSectionTitle = message({
  id: 'mkt-ssr.footer.developers_section_title',
  defaultMessage: 'Developers',
  description: 'The title for the developers section of the footer',
});

export const resourcesSectionTitle = message({
  id: 'mkt-ssr.footer.resources_section_title',
  defaultMessage: 'Resources',
  description: 'The title for the resources section of the footer',
});

export const companySectionTitle = message({
  id: 'mkt-ssr.footer.company_section_title',
  defaultMessage: 'Company',
  description: 'The title for the company section of the footer',
});

export const supportSectionTitle = message({
  id: 'mkt-ssr.footer.support_section_title',
  defaultMessage: 'Support',
  description: 'The title for the support section of the footer',
});

// Link labels
export const pricingLabel = message({
  id: 'mkt-ssr.footer.pricing_label',
  defaultMessage: 'Pricing',
  description: 'The label for the pricing link in the footer',
});
export const startupsLabel = message({
  id: 'mkt-ssr.footer.startups_label',
  defaultMessage: 'Startups',
  description: 'The label for the startups link in the footer',
});
export const enterprisesLabel = message({
  id: 'mkt-ssr.footer.enterprises_label',
  defaultMessage: 'Enterprises',
  description: 'The label for the enterprises link in the footer',
});
export const platformsLabel = message({
  id: 'mkt-ssr.footer.platforms_label',
  defaultMessage: 'Platforms',
  description: 'The label for the platforms link in the footer',
});
export const ecommerceLabel = message({
  id: 'mkt-ssr.footer.ecommerce_label',
  defaultMessage: 'Ecommerce',
  description: 'The label for the ecommerce link in the footer',
});
export const marketplacesLabel = message({
  id: 'mkt-ssr.footer.marketplaces_label',
  defaultMessage: 'Marketplaces',
  description: 'The label for the marketplaces link in the footer',
});
export const cryptoLabel = message({
  id: 'mkt-ssr.footer.crypto_label',
  defaultMessage: 'Crypto',
  description: 'The label for the crypto link in the footer',
});
export const creatorEconomyLabel = message({
  id: 'mkt-ssr.footer.creator_economy_label',
  defaultMessage: 'Creator economy',
  description: 'The label for the creator economy link in the footer',
});
export const embeddedFinanceLabel = message({
  id: 'mkt-ssr.footer.embedded_finance_label',
  defaultMessage: 'Embedded finance',
  description: 'The label for the embedded finance link in the footer',
});
export const globalBusinessesLabel = message({
  id: 'mkt-ssr.footer.global_businesses_label',
  defaultMessage: 'Global businesses',
  description: 'The label for the global businesses link in the footer',
});
export const inAppPaymentsLabel = message({
  id: 'mkt-ssr.footer.in_app_payments_label',
  defaultMessage: 'In-app payments',
  description: 'The label for the in-app payments link in the footer',
});
export const financeAutomationLabel = message({
  id: 'mkt-ssr.footer.finance_automation_label',
  defaultMessage: 'Finance automation',
  description: 'The label for the finance automation link in the footer',
});
export const insuranceLabel = message({
  id: 'mkt-ssr.footer.insurance_label',
  defaultMessage: 'Insurance',
  description: 'The label for the insurance link in the footer',
});
export const mediaAndEntertainmentLabel = message({
  id: 'mkt-ssr.footer.media_and_entertainment_label',
  defaultMessage: 'Media and Entertainment',
  description: 'The label for the media and entertainment link in the footer',
});
export const nonprofitsLabel = message({
  id: 'mkt-ssr.footer.nonprofits_label',
  defaultMessage: 'Nonprofits',
  description: 'The label for the nonprofits link in the footer',
});
export const retailLabel = message({
  id: 'mkt-ssr.footer.retail_label',
  defaultMessage: 'Retail',
  description: 'The label for the retail link in the footer',
});

export const partnerEcosystemLabel = message({
  id: 'mkt-ssr.footer.partner_ecosystem_label',
  defaultMessage: 'Partner ecosystem',
  description: 'The label for the partner ecosystem link in the footer',
});
export const professionalServicesLabel = message({
  id: 'mkt-ssr.footer.professional_services_label',
  defaultMessage: 'Professional services',
  description: 'The label for the professional services link in the footer',
});

export const documentationLabel = message({
  id: 'mkt-ssr.footer.documentation_label',
  defaultMessage: 'Documentation',
  description: 'The label for the documentation link in the footer',
});
export const apiReferenceLabel = message({
  id: 'mkt-ssr.footer.api_reference_label',
  defaultMessage: 'API reference',
  description: 'The label for the api reference link in the footer',
});
export const apiStatusLabel = message({
  id: 'mkt-ssr.footer.api_status_label',
  defaultMessage: 'API status',
  description: 'The label for the api status link in the footer',
});
export const apiChangelogLabel = message({
  id: 'mkt-ssr.footer.api_changelog_label',
  defaultMessage: 'API changelog',
  description: 'The label for the api changelog link in the footer',
});
export const librariesAndSdksLabel = message({
  id: 'mkt-ssr.footer.libraries_and_sdks_label',
  defaultMessage: 'Libraries and SDKs',
  description: 'The label for the libraries and SDKs link in the footer',
});
export const developerBlogLabel = message({
  id: 'mkt-ssr.footer.developer_blog_label',
  defaultMessage: 'Developer blog',
  description: 'The label for the developer blog link in the footer',
});

export const guidesLabel = message({
  id: 'mkt-ssr.footer.guides_label',
  defaultMessage: 'Guides',
  description: 'The label for the guides link in the footer',
});
export const customerStoriesLabel = message({
  id: 'mkt-ssr.footer.customer_stories_label',
  defaultMessage: 'Customer stories',
  description: 'The label for the customer stories link in the footer',
});
export const blogLabel = message({
  id: 'mkt-ssr.footer.blog_label',
  defaultMessage: 'Blog',
  description: 'The label for the blog link in the footer',
});
export const annualConferenceLabel = message({
  id: 'mkt-ssr.footer.annual_conference_label',
  defaultMessage: 'Sessions annual conference',
  description:
    'The label for the Sessions annual conference link in the footer',
});
export const privacyTermsLabel = message({
  id: 'mkt-ssr.footer.privacy_terms_label',
  defaultMessage: 'Privacy & terms',
  description: 'The label for the privacy & terms link in the footer',
});
export const moreResourcesLabel = message({
  id: 'mkt-ssr.footer.more_resources_label',
  defaultMessage: 'More resources',
  description: 'The label for the more resources link in the footer',
});
export const prohibitedBusinessesLabel = message({
  id: 'mkt-ssr.footer.prohibited_businesses_label',
  defaultMessage: 'Prohibited & restricted businesses',
  description:
    'The label for the prohibited & restricted businesses link in the footer',
});
export const licensesLabel = message({
  id: 'mkt-ssr.footer.licenses_label',
  defaultMessage: 'Licenses',
  description: 'The label for the licenses link in the footer',
});
export const sitemapLabel = message({
  id: 'mkt-ssr.footer.sitemap_label',
  defaultMessage: 'Sitemap',
  description: 'The label for the sitemap link in the footer',
});
export const cookieSettingsLabel = message({
  id: 'mkt-ssr.footer.cookie_settings_label',
  defaultMessage: 'Cookie settings',
  description: 'The label for the cookie settings link in the footer',
});
export const privacyChoicesLabel = message({
  id: 'mkt-ssr.footer.privacy_choices_label',
  defaultMessage: 'Your privacy choices',
  description: 'The label for the your privacy choices link in the footer',
});
export const legalNotice = message({
  id: 'mkt-ssr.footer.legal_notice_label',
  defaultMessage: 'Legal notice',
  description: 'The label for the legal notice link in the footer',
});

export const jobsLabel = message({
  id: 'mkt-ssr.footer.jobs_label',
  defaultMessage: 'Jobs',
  description: 'The label for the jobs link in the footer',
});
export const newsroomLabel = message({
  id: 'mkt-ssr.footer.newsroom_label',
  defaultMessage: 'Newsroom',
  description: 'The label for the newsroom link in the footer',
});

export const supportCenterLabel = message({
  id: 'mkt-ssr.footer.support_center_label',
  defaultMessage: 'Support center',
  description: 'The label for the support center link in the footer',
});
export const supportPlansLabel = message({
  id: 'mkt-ssr.footer.support_plans_label',
  defaultMessage: 'Support plans',
  description: 'The label for the support plans link in the footer',
});
export const caPhoneLabel = message({
  id: 'mkt-ssr.footer.ca_phone_label',
  defaultMessage: 'CA residents:',
  description: 'The label for the CA residents phone number in the footer',
});

export const institutionalLinkLabel = message({
  id: 'mkt-ssr.footer.institutional_link_label',
  defaultMessage: 'Institutional',
  description: 'The label for the Institutional page in the footer for Brazil',
});
